import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { documents } from "@api/courses/contents/contentDocuments/path";

const pathBase = `/courses/:courseId/content/`;
const pathById = `${pathBase}:contentId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const contents = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  documents,
} as const;
